import * as React from 'react';
import SecondaryButton from '../../../../common/secondary-button';
import * as styles from '../navigation.module.scss';
import { TextField } from '@material-ui/core';
import Navigation from '../../../../../models/navigation';
import { NewNavigation } from '../../../../../hooks/useNavigation';

interface Props {
  inputText: string;
  setInputText: (text: string) => void;
  navigations: Navigation[];
  updating: boolean;
  addNavigationHandler: (navigation: NewNavigation) => void;
}

const AddCategory = ({ inputText, setInputText, navigations, updating, addNavigationHandler }: Props) => {
  const addCategoryHandler = (event?: React.FormEvent<HTMLFormElement>) => {
    event && event.preventDefault();
    if (inputText) {
      const seqOrder = navigations.length;
      const newCategory = {
        seqOrder,
        name: inputText
      };
      addNavigationHandler(newCategory);
    }
  };

  return (
    <form onSubmit={event => addCategoryHandler(event)}>
      <TextField
        id="outlined-name"
        label="Name"
        size="small"
        margin="none"
        variant="outlined"
        value={inputText}
        onChange={(event: any) => setInputText(event.target.value)}
        disabled={updating}
        className={styles.categoryNameInput}
      />
      <SecondaryButton
        text="Add"
        title="Add"
        handleClick={addCategoryHandler}
        deactive={inputText === '' || updating}
      />
    </form>
  );
};

export default AddCategory;
